import { render, staticRenderFns } from "./alistgroup.vue?vue&type=template&id=f22bcf56&scoped=true"
import script from "./alistgroup.vue?vue&type=script&lang=js"
export * from "./alistgroup.vue?vue&type=script&lang=js"
import style0 from "./alistgroup.vue?vue&type=style&index=0&id=f22bcf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22bcf56",
  null
  
)

export default component.exports